import React from 'react';
import './StudentHome.scss';
import { useNavigate } from 'react-router';
import logosMain from '../../assets/img/logos-image-main-sun.png';
import booksImage from '../../assets/img/books-main.png';
import { useTranslation } from 'react-i18next';

const StudentHome = () => {
  const navigation = useNavigate();

  const { t } = useTranslation();

  return (
    <div className="student-home">
      <div className="content-images">
        <div className="logos">
          <img src={logosMain} alt="logos-main" />
        </div>

        <div className="books">
          <img src={booksImage} alt="books" />
        </div>
      </div>

      <button className="lib-btn" type="button" onClick={() => navigation('/library')}>
        {t('library').toUpperCase()}
      </button>
    </div>
  );
};

export default StudentHome;
